import { LocationAddress } from "../types/store";

const readComponent = (components: any[], ...types: string[]) => {
  const match = components.find((component) =>
    types.some((type) => Array.isArray(component?.types) && component.types.includes(type)),
  );
  return match?.long_name || "";
};

const toLocationAddress = (result: any): LocationAddress => {
  const components = Array.isArray(result?.address_components) ? result.address_components : [];
  const route = readComponent(components, "route");
  const neighborhood = readComponent(components, "neighborhood", "sublocality", "sublocality_level_1");
  const locality = readComponent(components, "locality", "postal_town");
  const district = readComponent(components, "administrative_area_level_3", "administrative_area_level_2");
  const country = readComponent(components, "country") || "India";

  return {
    houseNumber: readComponent(components, "street_number"),
    buildingName: readComponent(components, "premise", "subpremise", "establishment"),
    street: route,
    area: neighborhood,
    villageTownCity: locality || district,
    district,
    state: readComponent(components, "administrative_area_level_1"),
    country,
    pinCode: readComponent(components, "postal_code"),
    formattedAddress: result?.formatted_address || "",
  };
};

const getGoogleMaps = () => (window as typeof window & { google?: { maps?: any } }).google?.maps;

export const reverseGeocodeLocation = async (latitude: number, longitude: number) => {
  const googleMaps = getGoogleMaps();
  if (!googleMaps?.Geocoder) {
    throw new Error("Google Maps is not ready yet. Please wait and try again.");
  }

  const geocoder = new googleMaps.Geocoder();
  const response = await geocoder.geocode({
    location: { lat: latitude, lng: longitude },
  });
  const result = response?.results?.[0];

  if (!result) {
    throw new Error("We could not find a precise address for that location.");
  }

  return toLocationAddress(result);
};
